import gifxchangeLogo from '../../../assets/img/logo-giftxchange.png'
import fantabulousfreddLogo from '../../../assets/img/logo-fantabulousfredd.jpeg'
import santasLogo from '../../../assets/img/logo-santa.webp'
import smartvLogo from '../../../assets/img/logo-smartvads.png'
import oraleTaqueroLogo from '../../../assets/img/logo-orale-taquero.webp'

const proyects = [
    {
        class: 'oraletaquero',
        name: '¡Orale Taquero!',
        description: '¡La taquería te espera! Prepara tacos, sirve aguas frescas y domina los pedidos en Carrera o pon a prueba tu ritmo en Arcade.',
        downloads: '1',
        icon: oraleTaqueroLogo,
        web: 'https://apps.apple.com/app/id6824362438',
        android: 'https://play.google.com/store/apps/details?id=com.kinsolutionsystems.oraletaquero',
        ios: 'https://apps.apple.com/app/id6824362438'
    },
    {
        class: 'fantabulousfredd',
        name: 'Fantabulous Fredd',
        description: 'The past is back in your hands!',
        downloads: 'Download now!',
        icon: fantabulousfreddLogo,
        web: 'https://apps.apple.com/mx/app/fantabulous-fredd/id6757886803',
        ios: 'https://apps.apple.com/mx/app/fantabulous-fredd/id6757886803'
    },
    {
        class: 'giftxchange',
        name: 'Intercambio de regalos',
        description: 'Realiza intercambios con tus amigos o colegas del trabajo.',
        downloads: '+400K',
        icon: gifxchangeLogo,
        web: 'https://giftxchange.app',
        android: 'https://play.google.com/store/apps/details?id=com.kinsolutionsystems.intercambionavidenio',
        ios: 'https://apps.apple.com/mx/app/intercambio-de-regalos/id1593113147?l=en-GB?l=en'
    },
    {
        class: 'santasmailbox',
        name: 'Buzón de Santa',
        description: 'Escribe tu carta a Santa y recibe lo que deseas para esta navidad.',
        downloads: '+10K',
        icon: santasLogo,
        web: 'https://buzondesanta.kinsolutionsystems.com',
        android: 'https://play.google.com/store/apps/details?id=com.kinsolutionsystems.buzonsanta',
        ios: 'https://apps.apple.com/mx/app/buz%C3%B3n-de-santa-claus/id1639643573?l=es'
    },
    {
        class: 'smartvads',
        name: 'SmarTV Ads',
        description: 'Con SmarTV Ads podrás configurar cualquier Android TV como un cartel publicitario.',
        downloads: '+100',
        icon: smartvLogo,
        web: 'https://smartvads.com/',
        android: 'https://play.google.com/store/apps/details?id=com.kinsolutionsystems.com.smartvsigns.tv',
        ios: ''
    }
]

export default proyects